import { on } from "@ngrx/store";
import { PagesStore } from "../../pages.state";
import { updateVersionInState } from "../quote.utils";
import { QuoteVersionActions } from "./version.actions";

// **************************************************************************
// VERSION SUCCESS REDUCERS
// **************************************************************************

const versionSuccess = on(
    QuoteVersionActions.createNewVersionSuccess,
    QuoteVersionActions.updateVersionSuccess,
    QuoteVersionActions.changeVersionSuccess,
    QuoteVersionActions.updateDiscountSuccess,
    QuoteVersionActions.updateKickbackSuccess,
    QuoteVersionActions.updateManagementSuccess,
    QuoteVersionActions.updateSummarySuccess,
    QuoteVersionActions.updateVendorSuccess,
    QuoteVersionActions.updateVendorSummarySuccess,
    QuoteVersionActions.updateQuoteOptionsSuccess,
    QuoteVersionActions.patchIncludeCustomerPriceDecimalsSuccess,
    QuoteVersionActions.refreshInterestRateSuccess,
    (state: PagesStore, { version }) => ({
        ...state,
        quote: updateVersionInState(state.quote, version),
    }),
);

// **************************************************************************
// VERSION FAILURE REDUCERS
// **************************************************************************

const versionFailure = on(
    QuoteVersionActions.createNewVersionFailure,
    QuoteVersionActions.updateVersionFailure,
    QuoteVersionActions.changeVersionFailure,
    QuoteVersionActions.updateDiscountFailure,
    QuoteVersionActions.updateKickbackFailure,
    QuoteVersionActions.updateManagementFailure,
    QuoteVersionActions.updateSummaryFailure,
    QuoteVersionActions.updateVendorFailure,
    QuoteVersionActions.updateVendorSummaryFailure,
    QuoteVersionActions.updateQuoteOptionsFailure,
    QuoteVersionActions.patchIncludeCustomerPriceDecimalsFailure,
    QuoteVersionActions.refreshInterestRateFailure,
    (state: PagesStore, { error }) => ({
        ...state,
        quote: { ...state.quote, error },
    }),
);

// **************************************************************************
// EXPORT
// **************************************************************************

export const versionReducer = [versionSuccess, versionFailure];
